import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../../core/services/auth.service';
import { GlobalName } from '../../../../../core/utils/global-name';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-forget-password',
    templateUrl: './forget-password.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent],
    styleUrls: ['./forget-password.component.css']
})
export class ForgetPasswordComponent implements OnInit {
loading:any
mailSent=false;

  constructor(
    
    private authService:AuthService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
    
  }


  sendMail(value:any){
    this.loading=true
    this.authService.sendMail(value).subscribe((res:any)=>{
      this.loading=false
      this.mailSent=true
     
    },
    (err:any)=>{
      this.loading=false
      this.toastr.success('Connexion échoué', 'Connexion');

    });
  }
}
